import styled from 'styled-components';
export const ProductDetailContainer = styled.div.withConfig({
  displayName: "Detailstyle__ProductDetailContainer",
  componentId: "sc-1rbln5g-0"
})(["", ""], {
  "position": "relative"
});
export const ButtonContainer = styled.div.withConfig({
  displayName: "Detailstyle__ButtonContainer",
  componentId: "sc-1rbln5g-1"
})(["", " @media (max-width:", "){", " >div{", "}}"], {
  "marginTop": "1rem",
  "marginBottom": "1rem",
  "display": "flex",
  "justifyContent": "flex-end",
  "gap": "0.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "1rem"
}, {
  "height": "3rem",
  "width": "3rem",
  "flexGrow": "0"
});
export const BuyButton = styled.button.withConfig({
  displayName: "Detailstyle__BuyButton",
  componentId: "sc-1rbln5g-2"
})(["", " background:linear-gradient(90deg,#CE0E2D 0%,#DF2B41 100%);box-shadow:0px 8px 12px 0px #df2b4133;@media (max-width:", "){", "}"], {
  "display": "flex",
  "width": "110px",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.375rem",
  "borderRadius": "0.5rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.375rem",
  "paddingBottom": "0.375rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "flexGrow": "8"
});